import Icon from '../components/Icon.vue'

Icon.register({
  'dice-four': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M384 32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64h-320c-35.3 0-64-28.7-64-64v-320c0-35.3 28.7-64 64-64h320zM128 384c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM128 192c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM320 384c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM320 192c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dice-four.js
// module id = 1261
// module chunks = 0